// adminportal/src/RoutesIndex.tsx
import { Link } from 'react-router-dom';

/**
 * Dev-only page index — hyperlink to anything while wiring pages.
 * Hit it at:  /#/__pages
 * Add/remove links here as needed.
 */
export default function RoutesIndex() {
  const items = [
    { path: '/admin-dashboard', label: 'Dashboard (protected)' },
    { path: '/admin/users', label: 'Users (protected)' },
    { path: '/admin/companies', label: 'Companies (protected)' },
    { path: '/admin/settings', label: 'Settings (protected)' },
    { path: '/login', label: 'Login (public)' },
    // add any deep links you want to test:
    { path: '/admin/users/create', label: 'Create User (protected)' },
    { path: '/admin/users/update/123', label: 'Update User (protected)' },
    { path: '/admin/users/created', label: 'User Created (protected)' },
  ];

  return (
    <div className='min-h-screen bg-slate-950 text-slate-100'>
      <header className='sticky top-0 z-10 border-b border-white/10 bg-black/30 backdrop-blur'>
        <div className='mx-auto max-w-5xl px-4 py-3 flex items-center justify-between'>
          <div className='font-semibold'>All Pages (dev helper)</div>
          <Link
            to='/login'
            className='rounded-lg px-3 py-2 text-sm text-slate-300 hover:bg-white/10'
          >
            Go to Login
          </Link>
        </div>
      </header>

      <main className='mx-auto max-w-5xl px-4 py-8'>
        <p className='text-slate-300 mb-4'>
          Using <code className='text-slate-200'>HashRouter</code>, so routes render under{' '}
          <code className='text-slate-200'>/#/…</code>.
        </p>

        <ul className='grid sm:grid-cols-2 gap-3'>
          {items.map(r => (
            <li key={r.path}>
              <Link
                to={r.path}
                className='block rounded-xl border border-white/10 bg-white/5 p-4 hover:bg-white/10 transition'
              >
                <div className='text-base font-semibold'>{r.label}</div>
                <div className='text-xs text-slate-400 mt-1'>path: {r.path}</div>
              </Link>
            </li>
          ))}
        </ul>

        <div className='mt-8'>
          <Link
            to='/login'
            className='inline-flex items-center gap-2 rounded-lg bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white hover:bg-indigo-500'
          >
            ← Back to Login
          </Link>
        </div>
      </main>
    </div>
  );
}
